export const SET_DATA = (state, { id, data, isPush }) => {
  if (isPush) {
    state[id].push(data);
    return;
  }
  state[id] = data;
};
export const SET_DATA_BOOLEAN = (state, { id, index, key, value }) => {
  state[id][index][key] = value;
};
export const REMOVE_INDEX = (state, { id, index }) => {
  state[id].splice(index, 1);
};
export const setInstructors = (state, items) => {
  items.forEach(t => {
    t.isEdit = false;
  });
  state.instructors = items;
};
export const setInstructorsDactive = (state, items) => {
  items.forEach(t => {
    t.isEdit = false;
  });
  state.instructorsDactive = items;
};
export const clear = state => {
  state.instructors = [];
  state.instructorsDactive = [];
};
export const removeTrue = (state, index) => {
  state.instructors.splice(index, 1);
};
export const removeFalse = (state, index) => {
  state.instructorsDactive.splice(index, 1);
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/all-courses/mutations.js